import React from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { GET_SYSTEM_SETTINGS } from '../apollo/queries/settingsQueries';
import ImageWithPlaceholder from './ImageWithPlaceholder';
import './css/Footer.css';

const Footer = () => {
    const { data: settingsData, loading } = useQuery(GET_SYSTEM_SETTINGS, {
        errorPolicy: 'ignore', // 에러가 발생해도 기본값 사용
        fetchPolicy: 'cache-and-network', // 캐시와 네트워크 둘 다 사용
        notifyOnNetworkStatusChange: true // 네트워크 상태 변경 시 알림
    });

    // 기본값 설정
    const defaultSettings = {
        companyName: "부스바월드",
        businessNumber: "234-56-00745",
        address: "경기도 안양시 동안구 엘에스로 92, 32동 122호(호계동, 국제유통단지)",
        phone: "031-479-1630",
        fax: "000-0000-0000",
        email: "info@busbarworld.com",
        businessHours: "평일:오전9시~오후6시",
        businessDays: "토요일/일요일/공휴일 휴무",
        copyright: "Copyrightⓒ 부스바월드. All right reserved."
    };

    // 설정 데이터가 있으면 사용하고, 없으면 기본값 사용
    const settings = settingsData?.getSystemSettings || defaultSettings;
    const {
        companyName = defaultSettings.companyName,
        businessNumber = defaultSettings.businessNumber,
        address = defaultSettings.address,
        phone = defaultSettings.phone,
        fax = defaultSettings.fax,
        email = defaultSettings.email,
        businessHours = defaultSettings.businessHours,
        businessDays = defaultSettings.businessDays,
        copyright = defaultSettings.copyright
    } = settings;

    return (
        <footer className="footer-container">
            <div className="footer-content">
                <div className="footer-left">
                    <div className="footer-logo">
                        <ImageWithPlaceholder src="/logoFooter.png" alt={companyName} />
                    </div>
                    <div className="footer-company-info">
                        <p className="company-name">{companyName}</p>
                        <p>사업자등록 번호 : {businessNumber}</p>
                        <p>{address}</p>
                        <p className="copyright">{copyright}</p>
                    </div>
                </div>
                <div className="footer-right">
                    <div className="footer-links">
                        <a 
                            href="/terms-of-service" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            onClick={(e) => {
                                e.preventDefault();
                                window.open('/terms-of-service', '_blank', 'width=900,height=700,scrollbars=yes');
                            }}
                        >
                            이용약관
                        </a>
                        <a 
                            href="/privacy-policy" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            onClick={(e) => {
                                e.preventDefault();
                                window.open('/privacy-policy', '_blank', 'width=900,height=700,scrollbars=yes');
                            }}
                        >
                            개인정보처리방침
                        </a>
                    </div>
                    <div className="footer-contact-info">
                        <p>{businessHours}</p>
                        <p>{businessDays}</p>
                        <p>전화번호 {phone}</p>
                        <p>팩스번호 {fax}</p>
                        <p>이메일 {email}</p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer; 